/* CN cadeaus: cadeaumotor en voortgangsbalk. Uitleg en instellingen:
   snippets/cn-cadeau.liquid (gegevens in window.CN_CADEAU). */
(function () {
  'use strict';
  if (window.cnCadeau) return;

  var D = window.CN_CADEAU || {};
  var cfg = D.config || {};
  var I = D.i18n || {};
  var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var JSON_HDRS = { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
  var OFFSET = Number(D.offset) || 0;

  /* ── Instellingen uit de app ─────────────────────────────────────── */
  function idOf(gid) {
    var m = String(gid == null ? '' : gid).match(/(\d+)\s*$/);
    return m ? Number(m[1]) : null;
  }
  var gifts = (Array.isArray(cfg.gifts) ? cfg.gifts : [])
    .filter(function (g) {
      return g && g.id && g.enabled !== false && Array.isArray(g.variantIds) && g.variantIds.length
        && isFinite(Number(g.threshold));
    })
    .map(function (g) {
      return {
        id: String(g.id),
        threshold: Number(g.threshold),
        title: g.title || String(g.id),
        vids: g.variantIds.map(idOf).filter(Boolean),
      };
    })
    .sort(function (a, b) { return a.threshold - b.threshold; });
  var excludedProducts = (cfg.excludedProductIds || []).map(idOf).filter(Boolean);
  /* Zonder lijst in de config: dezelfde standaard als de kassaregel (statiegeld). */
  var excludedTypes = (Array.isArray(cfg.excludedProductTypes) ? cfg.excludedProductTypes : ['Fee', 'Percentage Fee', 'Fee Placeholder'])
    .map(function (t) { return String(t).trim().toLowerCase(); });

  /* ── Regels herkennen ────────────────────────────────────────────── */
  function props(it) { return (it && it.properties) || {}; }
  function giftIdOf(it) {
    var v = props(it)._cn_cadeau;
    return (v === undefined || v === null || v === '') ? null : String(v);
  }
  function isGiftLine(it) { return giftIdOf(it) !== null; }
  /* Cadeauregel van BOGOS (van vóór de omschakeling): ruimen we op. */
  function isLegacyGift(it) {
    var p = props(it);
    return p._bogos_trigger_type === 'gift' || p._is_free_gift === true || p._is_free_gift === 'true';
  }
  /* Bij welk cadeau hoort deze regel? Zelfde regels als de kassaregel:
     het cadeau-id moet kloppen én de variant moet bij dat cadeau horen.
     Een andere waarde (bv. "1") matcht op variant. */
  function giftForLine(it) {
    var id = giftIdOf(it);
    if (id === null) return null;
    var vid = Number(it.variant_id);
    var byId = null;
    for (var i = 0; i < gifts.length; i++) if (gifts[i].id === id) byId = gifts[i];
    if (byId) return byId.vids.indexOf(vid) !== -1 ? byId : null;
    for (var j = 0; j < gifts.length; j++) if (gifts[j].vids.indexOf(vid) !== -1) return gifts[j];
    return null;
  }

  /* ── Drempelbedrag ─────────────────────────────────────────────────
     Telt mee: elke regel zonder _cn_cadeau en zonder _cn_gift
     (bundelcadeau), geen cadeaubon, niet uitgesloten op product of
     producttype. Dezelfde uitzonderingen als de kassaregel. */
  function countsForThreshold(it) {
    if (isGiftLine(it) || isLegacyGift(it)) return false;
    if (props(it)._cn_gift) return false;
    if (it.gift_card) return false;
    if (excludedProducts.indexOf(Number(it.product_id)) !== -1) return false;
    var t = String(it.product_type || '').trim().toLowerCase();
    if (t && excludedTypes.indexOf(t) !== -1) return false;
    return true;
  }
  /* Zo rekent de kassaregel: prijzen vóór kortingen (hij ziet andere
     kortingen niet). In centen, valuta van de winkelwagen. */
  function baseCents(cart) {
    var sum = 0;
    ((cart && cart.items) || []).forEach(function (it) {
      if (countsForThreshold(it)) sum += Number(it.original_line_price) || 0;
    });
    return sum;
  }
  /* Wat de klant betaalt voor die regels: het totaal na alle kortingen
     (ook codes op de hele bestelling), min de regels die niet meetellen.
     Zo rekende BOGOS ook. */
  function paidCents(cart) {
    var sum = Number(cart && cart.total_price) || 0;
    ((cart && cart.items) || []).forEach(function (it) {
      if (!countsForThreshold(it)) sum -= Number(it.final_line_price) || 0;
    });
    return Math.max(0, sum);
  }
  /* Het thema telt wat de klant betaalt en nooit meer dan de kassaregel
     telt. Een cadeau dat het thema neerlegt, maakt de kassaregel dus
     altijd gratis (behalve bij een kortingscode die niet combineert, zie
     blocked hieronder). */
  function qualifyingCents(cart) { return Math.min(paidCents(cart), baseCents(cart)); }
  function rate() {
    var r = window.Shopify && window.Shopify.currency && Number(window.Shopify.currency.rate);
    return r > 0 ? r : 1;
  }
  function needCents(g) { return Math.round(g.threshold * rate() * 100); }
  function eligible(g, cents) { return cents >= needCents(g); }

  /* ── Geheugen voor deze sessie ──────────────────────────────────── */
  var KEY_REFUSED = 'cn_cadeau_geweigerd_v1';
  var KEY_CHOICE = 'cn_cadeau_keuze_v1';
  var REFUSE_MS = 30 * 60 * 1000;
  function load(key) { try { return JSON.parse(sessionStorage.getItem(key) || '{}') || {}; } catch (e) { return {}; } }
  function save(key, obj) { try { sessionStorage.setItem(key, JSON.stringify(obj)); } catch (e) { /* in-memory werkt door */ } }
  var refused = load(KEY_REFUSED);    // cadeau-id -> verloopt (ms)
  var choice = load(KEY_CHOICE);      // cadeau-id -> gekozen variant-id
  var unavailable = {};               // "cadeau:variant" -> true (toevoegen mislukte op deze pagina)
  function isRefused(id) {
    var e = refused[id];
    if (!e) return false;
    if (e < Date.now()) { delete refused[id]; save(KEY_REFUSED, refused); return false; }
    return true;
  }
  function refuse(id) { if (id) { refused[id] = Date.now() + REFUSE_MS; save(KEY_REFUSED, refused); } }
  function unrefuse(id) { if (refused[id]) { delete refused[id]; save(KEY_REFUSED, refused); } }
  function resetRefusals() { if (Object.keys(refused).length) { refused = {}; save(KEY_REFUSED, refused); } }

  /* Cadeau ligt erin, de drempel is gehaald, maar Shopify maakt het niet
     gratis. Meestal door een kortingscode die niet met productkortingen
     combineert (Shopify kiest dan de grootste korting), soms omdat de
     kassaregel uit staat. Dan halen we het weg en zetten het niet terug
     zolang dezelfde kortingscodes erop staan. Gaat de code eraf, dan komt
     het cadeau vanzelf terug. Zonder code (kassaregel uit) proberen we het
     na 10 minuten opnieuw. */
  var KEY_BLOCKED = 'cn_cadeau_geblokkeerd_v1';
  var blocked = load(KEY_BLOCKED);    // cadeau-id -> { codes, until }
  /* null = onbekend (een winkelwagen zonder discount_codes): dan laten we een
     blokkade staan tot een winkelwagen met codes uitsluitsel geeft. */
  function codesOf(cart) {
    if (!cart || !Array.isArray(cart.discount_codes)) return null;
    return cart.discount_codes
      .filter(function (d) { return d && d.applicable; })
      .map(function (d) { return String(d.code || '').toLowerCase(); })
      .sort().join(',');
  }
  function blockInfo(id, cart) {
    var b = blocked[id];
    if (!b) return null;
    var codes = codesOf(cart);
    if (b.until > Date.now() && (codes === null || b.codes === codes)) return b;
    delete blocked[id];
    save(KEY_BLOCKED, blocked);
    return null;
  }
  function block(id, cart) {
    var codes = codesOf(cart) || '';
    blocked[id] = { codes: codes, until: Date.now() + (codes ? 12 * 3600 * 1000 : 10 * 60 * 1000) };
    save(KEY_BLOCKED, blocked);
  }

  function variantInfo(g, vid) {
    var p = (D.products || {})[g.id];
    var vs = (p && p.variants) || [];
    for (var i = 0; i < vs.length; i++) if (Number(vs[i].id) === vid) return vs[i];
    return null;
  }
  /* Catalogusprijs van een cadeauregel in centen, voor de doorgestreepte
     waarde naast "Gratis". Zet de cart transform het cadeau op €0, dan
     staat de echte prijs nergens meer in de winkelwagen. */
  function listPrice(it) {
    var g = isGiftLine(it) ? giftForLine(it) : null;
    var v = g ? variantInfo(g, Number(it.variant_id)) : null;
    return v && Number(v.price) > 0 ? Number(v.price) : null;
  }
  function isAvailable(g, vid) {
    if (unavailable[g.id + ':' + vid]) return false;
    var v = variantInfo(g, vid);
    return v ? v.available !== false : true;
  }
  /* Welke variant leggen we neer: de keuze van de klant, anders de eerste beschikbare. */
  function variantFor(g) {
    var pref = Number(choice[g.id]);
    if (pref && g.vids.indexOf(pref) !== -1 && isAvailable(g, pref)) return pref;
    for (var i = 0; i < g.vids.length; i++) if (isAvailable(g, g.vids[i])) return g.vids[i];
    return null;
  }

  /* ── Wat moet er gebeuren? ─────────────────────────────────────── */
  function plan(cart) {
    var ops = { remove: [], setOne: [], add: [] };
    if (!cart || !Array.isArray(cart.items)) return ops;
    var cents = qualifyingCents(cart);
    /* Cadeauregels per cadeau. Let op: een regel van 2 stuks waarvan er één
       gratis is, toont Shopify als twee items van 1 met elk een eigen key
       (één €0, één betaald). */
    var byGift = {};
    cart.items.forEach(function (it) {
      if (!isGiftLine(it)) {
        if (isLegacyGift(it)) ops.remove.push(it.key);
        return;
      }
      var g = giftForLine(it);
      if (!g) { ops.remove.push(it.key); return; }
      (byGift[g.id] = byGift[g.id] || []).push(it);
    });
    gifts.forEach(function (g) {
      var items = byGift[g.id] || [];
      if (isRefused(g.id) || blockInfo(g.id, cart) || !eligible(g, cents)) {
        items.forEach(function (it) { ops.remove.push(it.key); });
        return;
      }
      var present = false;
      if (items.length) {
        /* Eén gratis stuk houden; extra of betaalde stuks eruit. */
        var keep = null;
        items.forEach(function (it) { if (!keep && Number(it.final_line_price) === 0) keep = it; });
        if (!keep) {
          var multi = null;
          items.forEach(function (it) { if (!multi && it.quantity > 1) multi = it; });
          if (multi) {
            /* Eén regel van meer stuks: terug naar 1, dan rekent Shopify opnieuw. */
            ops.setOne.push(multi.key);
            items.forEach(function (it) { if (it !== multi) ops.remove.push(it.key); });
            return;
          }
          /* Drempel gehaald maar niets gratis: geblokkeerd (zie block). */
          block(g.id, cart);
          items.forEach(function (it) { ops.remove.push(it.key); });
          return;
        }
        items.forEach(function (it) { if (it !== keep) ops.remove.push(it.key); });
        if (keep.quantity > 1) ops.setOne.push(keep.key);
        /* Klant koos een andere smaak/maat: oude regel weg, de nieuwe komt hieronder. */
        var pref = Number(choice[g.id]);
        if (pref && pref !== Number(keep.variant_id) && g.vids.indexOf(pref) !== -1 && isAvailable(g, pref)) {
          ops.remove.push(keep.key);
        } else {
          present = true;
        }
      }
      if (present) return;
      var vid = variantFor(g);
      if (vid) ops.add.push({ id: vid, quantity: 1, properties: { _cn_cadeau: g.id } });
    });
    return ops;
  }
  function hasOps(o) { return o.remove.length + o.setOne.length + o.add.length > 0; }

  function fetchCartJs() {
    return fetch(routes + 'cart.js', { cache: 'no-store', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  async function apply(o) {
    var updates = {};
    o.remove.forEach(function (k) { updates[k] = 0; });
    o.setOne.forEach(function (k) { updates[k] = 1; });
    if (Object.keys(updates).length) {
      await fetch(routes + 'cart/update.js', { method: 'POST', headers: JSON_HDRS, body: JSON.stringify({ updates: updates }) });
    }
    for (var i = 0; i < o.add.length; i++) {
      var item = o.add[i];
      var res = await fetch(routes + 'cart/add.js', { method: 'POST', headers: JSON_HDRS, body: JSON.stringify({ items: [item] }) });
      /* Uitverkocht of niet te koop: niet blijven proberen op deze pagina. */
      if (!res.ok) unavailable[item.properties._cn_cadeau + ':' + item.id] = true;
    }
  }

  /* reconcile(cart, opts): breng de cadeauregels in orde en geef de
     (verse) winkelwagen terug. Eén tegelijk: parallelle aanroepen wachten
     op elkaar en rekenen op een verse stand, zodat er nooit twee keer
     hetzelfde cadeau in komt. opts.fetchCart: de fetch van de lade
     (geeft een verrijkte winkelwagen terug). */
  var lock = Promise.resolve();
  var lastCart = null;
  function reconcile(cart, opts) {
    var run = lock.then(async function () {
      var c = cart;
      var o = plan(c);
      if (hasOps(o)) {
        var fresh = await fetchCartJs();
        if (fresh) { c = fresh; o = plan(c); }
      }
      if (!hasOps(o)) { remember(c); return c; }
      var fetchAfter = (opts && typeof opts.fetchCart === 'function') ? opts.fetchCart : fetchCartJs;
      /* Hooguit 3 rondes. Na het toevoegen kijken we of Shopify het cadeau
         ook echt gratis maakte; zo niet, dan markeert plan het als
         geblokkeerd en haalt de volgende ronde het weg. */
      for (var round = 0; round < 3 && hasOps(o); round++) {
        window.cnAddInFlight = true;
        try { await apply(o); } catch (e) { /* volgende ronde of volgende check */ }
        finally { window.cnAddInFlight = false; }
        var after = await fetchAfter();
        if (!after) break;
        c = after;
        o = plan(c);
      }
      remember(c);
      return c;
    });
    lock = run.catch(function () {});
    return run;
  }

  /* check(cart): niet-blokkerend, vanuit elke render van de lade en elk
     cart:updated-event. Klopt er iets niet, dan corrigeren we en tekenen we
     lade en winkelwagenpagina opnieuw. Loopt er al een correctie, dan
     kijken we daarna nog één keer (niets overslaan). Rem tegen een lus bij
     aanhoudende netwerkfouten: hooguit 4 per 15 s (daarna één keer later
     opnieuw) en 20 per pagina. */
  var checkBusy = false;
  var checkAgain = false;
  var checkTimes = [];
  var checkTimer = null;
  var checkRuns = 0;
  function check(cart) {
    remember(cart);
    if (!cart || !hasOps(plan(cart))) return;
    if (checkBusy) { checkAgain = true; return; }
    if (checkRuns >= 20) return;
    var now = Date.now();
    checkTimes = checkTimes.filter(function (t) { return now - t < 15000; });
    if (checkTimes.length >= 4) {
      if (!checkTimer) {
        checkTimer = setTimeout(function () { checkTimer = null; recheckFresh(); }, 15000 - (now - checkTimes[0]) + 100);
      }
      return;
    }
    checkTimes.push(now);
    checkRuns++;
    checkBusy = true;
    var done = function (c) {
      checkBusy = false;
      if (c) {
        if (typeof window.cnDrawerRefresh === 'function') window.cnDrawerRefresh();
        try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: c, source: 'cn-cadeau' } })); } catch (e) {}
      }
      if (checkAgain) { checkAgain = false; recheckFresh(); }
    };
    reconcile(cart).then(done, function () { done(null); });
  }
  function recheckFresh() {
    fetchCartJs().then(function (fresh) { check(fresh || lastCart); });
  }

  /* De klant gooit een cadeau weg: niet vanzelf terugzetten. */
  function noteRemoval(item) {
    if (!item) return;
    if (isGiftLine(item)) {
      var g = giftForLine(item);
      refuse(g ? g.id : giftIdOf(item));
    }
  }

  /* ── Voortgangsbalk: één grijs vlak met alle doelen op de balk ──────
     buildHtml() bouwt de widget één keer per set doelen; daarna past
     update() alleen klassen en waarden aan. Zo loopt de balk vloeiend
     mee, lichten de rondjes op en telt het bedrag mee, zonder dat de
     widget telkens opnieuw wordt opgebouwd. Opmaak: assets/snippet-cart-custom.css. */
  var mounts = [];
  var listExpanded = false;
  var renderQueued = false;
  var cacheTimer = null;
  /* Versie van de opbouw: ophogen bij elke wijziging in buildHtml, zodat een
     bewaarde oude weergave (sessionStorage) nooit in de nieuwe opbouw belandt. */
  var UI_VERSION = '2';
  var HTML_CACHE_KEY = 'cn_gifts_html_v' + UI_VERSION;
  var REDUCED = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var CHECK_SVG = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M3 6.3l2.1 2.1L9.2 4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHEVRON_SVG = '<svg class="cn-gifts__chev" viewBox="0 0 12 8" aria-hidden="true"><path d="M1 1l5 5 5-5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }
  /* De balk rekent in euro (zo staan de drempels in de app en in de
     thema-instellingen) en toont in de valuta van de klant: zelfde koers als
     de drempels (rate) en dezelfde opmaak als Liquid (cnMoney, cart-custom.liquid). */
  function toCents(eur) { return Math.round((Number(eur) || 0) * rate() * 100); }
  function fmtMoney(eur) {
    if (eur == null || isNaN(eur) || eur < 0) eur = 0;
    return window.cnMoney ? window.cnMoney(toCents(eur)) : '€' + eur.toFixed(2).replace('.', ',');
  }
  /* Ronde bedragen zonder ",00" (doelen op de balk: €50, €60). */
  function fmtShort(eur) {
    var c = toCents(eur);
    if (window.cnMoney) return window.cnMoney(c, { trim: true });
    return '€' + (c % 100 === 0 ? String(c / 100) : (c / 100).toFixed(2).replace('.', ','));
  }
  /* Waarde van een verzenddoel uit de instelling ("3,00", in euro). */
  function fmtWorth(w) {
    var n = parseFloat(String(w).replace(/\s/g, '').replace(',', '.'));
    return isFinite(n) ? fmtMoney(n) : '€' + w;
  }

  function buildGoals() {
    var list = [];
    gifts.forEach(function (g) {
      var prod = (D.products || {})[g.id] || {};
      list.push({
        key: 'gift:' + g.id,
        type: 'gift',
        gift: g,
        title: (D.labels || {})[g.id] || prod.title || g.title,
        thresholdEur: g.threshold + OFFSET,  // getoond (rond) bedrag
        unlockEur: g.threshold,              // echte drempel van de kassaregel
        icon: prod.image || '',              // productfoto; grijs zolang het niet gehaald is
      });
    });
    /* Verzenddoelen: het hoogste bedrag is gratis verzending, lagere bedragen
       zijn verzendkorting. Ze spelen precies op het bedrag vrij (zo rekent
       Shopify de verzendkosten), dus zonder het verschil van de cadeaus. */
    var ship = String(D.shipLine || '').split(/\s+/).map(function (part) {
      var kv = part.split('=');
      return { amount: parseFloat(String(kv[0] || '').replace(',', '.')), worth: String(kv[1] || '').trim() };
    }).filter(function (s) { return s.amount > 0; }).sort(function (a, b) { return a.amount - b.amount; });
    ship.forEach(function (s, i) {
      var kind = (D.shipKinds || {})[i === ship.length - 1 ? 'free' : 'discount'] || {};
      list.push({
        key: 'ship:' + s.amount,
        type: 'ship',
        title: kind.title || '',
        thresholdEur: s.amount,
        unlockEur: s.amount,
        worth: s.worth,
        icon: kind.lock || '',
      });
    });
    list.sort(function (a, b) { return a.thresholdEur - b.thresholdEur; });
    return list;
  }

  /* Bedragen voor de balk in euro, allebei wat de klant betaalt (na
     kortingen). Cadeaus: hetzelfde bedrag als waarop het cadeau erbij komt
     (qualifyingCents). Verzenddoelen: zoals Shopify de verzendkosten rekent,
     nagemeten op 14 okt met /cart/shipping_rates.json: het totaal na
     kortingen, mét statiegeld en zonder cadeaubonnen. */
  function amounts(cart) {
    var r = rate();
    var shipCents = Number(cart && cart.total_price) || 0;
    ((cart && cart.items) || []).forEach(function (it) {
      if (it.gift_card) shipCents -= Number(it.final_line_price) || 0;
    });
    return { gift: qualifyingCents(cart) / 100 / r, ship: Math.max(0, shipCents) / 100 / r };
  }
  function amountFor(goal, am) { return goal.type === 'gift' ? am.gift : am.ship; }
  function reached(goal, am) { return amountFor(goal, am) >= goal.unlockEur - 1e-9; }

  function giftLineIn(cart, g) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (isGiftLine(it) && giftForLine(it) === g) return it;
    }
    return null;
  }

  /* Wat ziet de klant bij dit doel: open (nog niet gehaald), got (gehaald),
     code (gehaald, maar een kortingscode houdt het cadeau tegen) of na
     (gehaald, maar niet beschikbaar, bv. uitverkocht). */
  function goalState(goal, cart, am) {
    if (!reached(goal, am)) return 'open';
    if (goal.type !== 'gift') return 'got';
    var blk = blockInfo(goal.gift.id, cart);
    if (blk) return blk.codes ? 'code' : 'na';
    if (!variantFor(goal.gift) && !giftLineIn(cart, goal.gift)) return 'na';
    return 'got';
  }
  /* Melding onder de kop: een gehaald cadeau dat een kortingscode tegenhoudt. */
  function codeBlocked(goals, cart, am) {
    return goals.some(function (g) { return g.type === 'gift' && goalState(g, cart, am) === 'code'; });
  }

  /* Keuze van smaak/maat en "Voeg toe" in de lijst. */
  function rowSide(goal, cart, am) {
    if (goal.type !== 'gift') return '';
    var g = goal.gift;
    if (!reached(goal, am) || blockInfo(g.id, cart)) return '';
    var line = giftLineIn(cart, g);
    var html = '';
    if (g.vids.length > 1) {
      var current = line ? Number(line.variant_id) : (Number(choice[g.id]) || variantFor(g));
      html += '<select class="cn-gifts__select" data-cn-gift-select="' + escapeHtml(g.id) + '" aria-label="' + escapeHtml(I.chooseSize) + '">';
      g.vids.forEach(function (vid) {
        var v = variantInfo(g, vid);
        var avail = isAvailable(g, vid);
        html += '<option value="' + vid + '"' + (vid === current ? ' selected' : '') + (avail ? '' : ' disabled') + '>'
          + escapeHtml((v && v.title) || String(vid)) + (avail ? '' : ' (' + escapeHtml(I.soldOut) + ')') + '</option>';
      });
      html += '</select>';
    }
    if (!line && isRefused(g.id) && variantFor(g)) {
      html += '<button type="button" class="cn-gifts__btn" data-cn-gift-readd="' + escapeHtml(g.id) + '">' + escapeHtml(I.addShort) + '</button>';
    }
    return html;
  }

  /* Doelen op gelijke afstand op de balk; het laatste doel aan het eind. */
  function stepPos(i, n) { return ((i + 1) / n) * 100; }
  /* Vulling stukje per stukje tussen de doelen, zodat een rondje precies
     oplicht op het moment dat het doel gehaald is. De vulling loopt tot het
     verste gehaalde doel en dan naar het doel erna. Meestal zijn dat de
     doelen op volgorde; met veel statiegeld (telt wel voor verzending, niet
     voor cadeaus) kan een verzenddoel eerder gehaald zijn dan het cadeau
     ervoor, en dan loopt de balk daar niet achter. */
  function fillPercent(goals, am) {
    var n = goals.length, last = -1;
    for (var i = 0; i < n; i++) if (reached(goals[i], am)) last = i;
    if (last === n - 1) return 100;
    var prevPos = last >= 0 ? stepPos(last, n) : 0;
    var prevAmt = last >= 0 ? goals[last].unlockEur : 0;
    var g = goals[last + 1], pos = stepPos(last + 1, n);
    var span = g.unlockEur - prevAmt;
    var frac = span > 0 ? Math.max(0, Math.min(1, (amountFor(g, am) - prevAmt) / span)) : 0;
    return prevPos + frac * (pos - prevPos);
  }

  function structureOf(goals) {
    return 'v' + UI_VERSION + '#' + goals.map(function (g) { return g.key + '~' + g.title + '~' + (g.icon || ''); }).join('|');
  }
  function dotHtml(goal, extraClass) {
    return '<span class="cn-gifts__dot' + (extraClass || '') + '">'
      + '<span class="cn-gifts__face">' + (goal.icon ? '<img src="' + escapeHtml(goal.icon) + '" alt="" loading="lazy" decoding="async">' : '') + '</span>'
      + '<span class="cn-gifts__check">' + CHECK_SVG + '</span>'
      + '</span>';
  }
  function buildHtml(goals) {
    var n = goals.length;
    var h = '<div class="cn-gifts" data-structure="' + escapeHtml(structureOf(goals)) + '">';
    h += '<p class="cn-gifts__msg"></p>';
    h += '<p class="cn-gifts__note" hidden></p>';
    h += '<div class="cn-gifts__track" role="progressbar" aria-label="' + escapeHtml(I.progressLabel || '') + '" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">';
    h += '<span class="cn-gifts__rail"><span class="cn-gifts__fill"></span></span>';
    goals.forEach(function (g, i) {
      h += '<span class="cn-gifts__step cn-gifts__step--' + g.type + '" style="--pos:' + stepPos(i, n).toFixed(3) + '%">'
        + dotHtml(g, '') + '<span class="cn-gifts__amt">' + escapeHtml(fmtShort(g.thresholdEur)) + '</span></span>';
    });
    h += '</div>';
    h += '<button type="button" class="cn-gifts__toggle" data-cn-toggle aria-expanded="false">'
      + '<span class="cn-gifts__toggle-text">' + escapeHtml(I.viewGifts || '') + '</span>'
      + '<span class="cn-gifts__count"></span>' + CHEVRON_SVG + '</button>';
    h += '<div class="cn-gifts__panel"><div class="cn-gifts__panel-inner"><ul class="cn-gifts__rows">';
    goals.forEach(function (g, i) {
      h += '<li class="cn-gifts__row cn-gifts__row--' + g.type + '" style="--i:' + i + '">'
        + dotHtml(g, ' cn-gifts__dot--row')
        + '<span class="cn-gifts__row-info"><span class="cn-gifts__row-title">' + escapeHtml(g.title) + '</span>'
        + '<span class="cn-gifts__row-meta"></span></span>'
        + '<span class="cn-gifts__row-side"><span class="cn-gifts__status"></span><span class="cn-gifts__form"></span></span>'
        + '</li>';
    });
    h += '</ul></div></div></div>';
    return h;
  }

  function headerHtml(next, remain) {
    if (!next) {
      return String(I.allUnlocked || '').replace('__CONGRATS__', '<strong>' + escapeHtml(I.congrats) + '</strong>');
    }
    return String(I.spendMore || '')
      .replace('__AMOUNT__', '<strong class="cn-gifts__amount" data-v="' + remain.toFixed(2) + '">' + escapeHtml(fmtMoney(remain)) + '</strong>')
      .replace('__TIER__', '<strong class="cn-gifts__tier">' + escapeHtml(next.title) + '</strong>');
  }
  function plainHeader(next, remain) {
    var d = document.createElement('div');
    d.innerHTML = headerHtml(next, remain);
    return (d.textContent || '').replace(/\s+/g, ' ').trim();
  }
  /* "Nog €X" telt vloeiend mee (±0,3 s). */
  function tweenAmount(el, to) {
    var from = parseFloat(el.getAttribute('data-v'));
    el.setAttribute('data-v', to.toFixed(2));
    if (el._cnRaf) cancelAnimationFrame(el._cnRaf);
    if (REDUCED || isNaN(from) || Math.abs(from - to) < 0.005 || !window.requestAnimationFrame) { el.textContent = fmtMoney(to); return; }
    var t0 = null;
    var step = function (t) {
      if (t0 === null) t0 = t;
      var p = Math.min(1, (t - t0) / 320);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmtMoney(from + (to - from) * e);
      el._cnRaf = p < 1 ? requestAnimationFrame(step) : null;
    };
    el._cnRaf = requestAnimationFrame(step);
  }
  /* Kop: zelfde doel → bedrag telt mee; ander doel → kort uit- en infaden. */
  function setMessage(msg, next, remain) {
    var key = next ? next.key : 'klaar';
    var prev = msg.getAttribute('data-next');
    msg._cnPending = { next: next, remain: remain };
    if (prev === key) {
      if (msg._cnSwapping) return;
      var amountEl = msg.querySelector('.cn-gifts__amount');
      if (amountEl) tweenAmount(amountEl, remain);
      else msg.innerHTML = headerHtml(next, remain);
      return;
    }
    msg.setAttribute('data-next', key);
    if (!prev || REDUCED) { msg.innerHTML = headerHtml(next, remain); return; }
    msg._cnSwapping = true;
    msg.classList.add('is-swap');
    setTimeout(function () {
      var p = msg._cnPending || { next: next, remain: remain };
      msg.innerHTML = headerHtml(p.next, p.remain);
      msg.classList.remove('is-swap');
      msg._cnSwapping = false;
    }, 160);
  }
  function setFlags(el, flags) { for (var k in flags) el.classList.toggle(k, !!flags[k]); }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function pop(step) {
    step.classList.remove('is-pop');
    void step.offsetWidth;
    step.classList.add('is-pop');
    setTimeout(function () { step.classList.remove('is-pop'); }, 650);
  }

  function update(root, goals, cart, am) {
    var next = null;
    for (var n = 0; n < goals.length; n++) { if (!reached(goals[n], am)) { next = goals[n]; break; } }
    var msg = root.querySelector('.cn-gifts__msg');
    if (msg) setMessage(msg, next, next ? Math.max(0, next.thresholdEur - amountFor(next, am)) : 0);
    var note = root.querySelector('.cn-gifts__note');
    if (note) {
      var showNote = codeBlocked(goals, cart, am);
      setText(note, showNote ? (I.codeBlocksGift || '') : '');
      note.hidden = !showNote;
    }
    var fill = fillPercent(goals, am);
    var fillEl = root.querySelector('.cn-gifts__fill');
    if (fillEl) fillEl.style.width = fill.toFixed(2) + '%';
    var track = root.querySelector('.cn-gifts__track');
    if (track) {
      track.setAttribute('aria-valuenow', String(Math.round(fill)));
      /* Schermlezers krijgen de eindtekst, niet het meetellende bedrag. */
      track.setAttribute('aria-valuetext', plainHeader(next, next ? Math.max(0, next.thresholdEur - amountFor(next, am)) : 0));
    }
    var steps = root.querySelectorAll('.cn-gifts__step');
    var rows = root.querySelectorAll('.cn-gifts__row');
    var got = 0;
    goals.forEach(function (goal, i) {
      var state = goalState(goal, cart, am);
      if (state === 'got') got++;
      var flags = { 'is-reached': state === 'got', 'is-blocked': state === 'code' || state === 'na', 'is-next': goal === next };
      var step = steps[i];
      if (step) {
        var was = step.classList.contains('is-reached');
        setFlags(step, flags);
        if (state === 'got' && !was && step.getAttribute('data-seen') === '1' && !REDUCED) pop(step);
        step.setAttribute('data-seen', '1');
      }
      var row = rows[i];
      if (!row) return;
      setFlags(row, flags);
      /* "Bij €60", of na het halen "t.w.v. €3,00" als er een waarde is ingesteld. */
      setText(row.querySelector('.cn-gifts__row-meta'), (state !== 'open' && goal.worth)
        ? String(I.worth || '__VALUE__').replace('__VALUE__', fmtWorth(goal.worth))
        : String(I.atAmount || '__AMOUNT__').replace('__AMOUNT__', fmtShort(goal.thresholdEur)));
      setText(row.querySelector('.cn-gifts__status'), state === 'got' ? (I.statusUnlocked || '')
        : state === 'code' ? (I.statusNotCombinable || I.statusNotAvailable || '')
        : state === 'na' ? (I.statusNotAvailable || '')
        : String(I.statusRemaining || '').replace('__AMOUNT__', fmtMoney(goal.thresholdEur - amountFor(goal, am))));
      var form = row.querySelector('.cn-gifts__form');
      if (form) {
        var fh = rowSide(goal, cart, am);
        if (form.getAttribute('data-html') !== fh) { form.innerHTML = fh; form.setAttribute('data-html', fh); }
      }
    });
    setText(root.querySelector('.cn-gifts__count'), got + '/' + goals.length);
    root.classList.toggle('is-complete', !next);
    root.classList.toggle('is-open', listExpanded);
    var tg = root.querySelector('[data-cn-toggle]');
    if (tg) tg.setAttribute('aria-expanded', listExpanded ? 'true' : 'false');
  }

  function render() {
    renderQueued = false;
    mounts = [].slice.call(document.querySelectorAll('.cn-bogos-progress'));
    if (!mounts.length) return;
    var goals = buildGoals();
    var cart = lastCart || D.cart;
    if (!goals.length || !cart) {
      mounts.forEach(function (el) { el.hidden = true; el.innerHTML = ''; });
      return;
    }
    var am = amounts(cart);
    var sig = structureOf(goals);
    mounts.forEach(function (el) {
      var root = el.querySelector('.cn-gifts');
      var fresh = !root || root.getAttribute('data-structure') !== sig;
      if (fresh) {
        el.innerHTML = buildHtml(goals);
        root = el.querySelector('.cn-gifts');
      }
      el.hidden = false;
      /* Nieuw opgebouwd: eerst de beginstand laten tekenen, dan groeit de balk. */
      if (fresh) void root.offsetWidth;
      update(root, goals, cart, am);
    });
    saveCacheSoon();
  }
  /* Laatste weergave (dichtgeklapt) bewaren: bij de volgende pagina staat de
     widget er meteen en loopt hij vanaf daar vloeiend bij. */
  function saveCacheSoon() {
    clearTimeout(cacheTimer);
    cacheTimer = setTimeout(function () {
      var root = mounts[0] && mounts[0].querySelector('.cn-gifts');
      if (!root) return;
      try {
        var clone = root.cloneNode(true);
        clone.classList.remove('is-open');
        var busy = clone.querySelectorAll('.is-pop, .is-swap');
        for (var i = 0; i < busy.length; i++) busy[i].classList.remove('is-pop', 'is-swap');
        sessionStorage.setItem(HTML_CACHE_KEY, clone.outerHTML);
      } catch (e) {}
    }, 700);
  }
  function scheduleRender() {
    if (renderQueued) return;
    renderQueued = true;
    (window.requestAnimationFrame || setTimeout)(render);
  }
  function remember(cart) {
    if (cart && Array.isArray(cart.items)) { lastCart = cart; scheduleRender(); }
  }

  /* "Voeg toe": klant wil een eerder weggegooid cadeau toch. */
  function readd(giftId) {
    unrefuse(giftId);
    check(lastCart || D.cart);
    scheduleRender();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || typeof t.closest !== 'function') return;
    var hit = t.closest('[data-cn-toggle], [data-cn-gift-readd]');
    if (!hit) return;
    e.preventDefault();
    if (hit.hasAttribute('data-cn-gift-readd')) { readd(hit.getAttribute('data-cn-gift-readd')); return; }
    /* Lijst open/dicht: alleen een klasse, de CSS animeert de hoogte. */
    listExpanded = !listExpanded;
    mounts.forEach(function (el) {
      var root = el.querySelector('.cn-gifts');
      if (!root) return;
      root.classList.toggle('is-open', listExpanded);
      var tg = root.querySelector('[data-cn-toggle]');
      if (tg) tg.setAttribute('aria-expanded', listExpanded ? 'true' : 'false');
    });
  });
  document.addEventListener('change', function (e) {
    var sel = e.target && e.target.closest && e.target.closest('[data-cn-gift-select]');
    if (!sel) return;
    var id = sel.getAttribute('data-cn-gift-select');
    choice[id] = Number(sel.value);
    save(KEY_CHOICE, choice);
    check(lastCart || D.cart);
  });

  /* Winkelwagen veranderd buiten de lade om (bv. bundel-app, andere pagina-
     onderdelen): opnieuw controleren. Onze eigen events slaan we over. */
  document.addEventListener('cart:updated', function (e) {
    var d = (e && e.detail) || {};
    if (d.source === 'cn-cadeau') return;
    if (d.cart && Array.isArray(d.cart.items)) { check(d.cart); return; }
    scheduleRender();
  });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) scheduleRender();
  });

  function init() {
    mounts = [].slice.call(document.querySelectorAll('.cn-bogos-progress'));
    /* Direct iets tonen (vorige weergave van deze sessie) terwijl de rest laadt. */
    try {
      var cached = sessionStorage.getItem(HTML_CACHE_KEY);
      if (cached) mounts.forEach(function (el) { if (el.hidden || !el.innerHTML) { el.innerHTML = cached; el.hidden = false; } });
    } catch (e) {}
    remember(D.cart);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  window.cnCadeau = {
    reconcile: reconcile,
    check: check,
    noteRemoval: noteRemoval,
    resetRefusals: resetRefusals,
    isGiftLine: function (it) { return isGiftLine(it) || isLegacyGift(it); },
    listPrice: listPrice,
    baseCents: baseCents,
    gifts: gifts,
    render: function () { render(); },
  };
})();
